import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: '/',
  },

  {
    label: 'SecureFarms',
    icon: 'FarmIcon',
    href: '/farms',
  },
  {
    label: 'SecurePools',
    icon: 'PoolIcon',
    href: '/nests',
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    items: [
      {
        label: 'Exchange',
        href: 'https://exchange.secureswap.io/#/swap?outputCurrency=0x73972F91fbFd8673Eafaab0105481A90D25E153d', // 'https://exchange.goosedefi.com/',
      },
      {
        label: 'Liquidity',
        href: 'https://exchange.secureswap.io/#/pool', // 'https://exchange.goosedefi.com/#/pool',
      },
    ],
  },
  // {
  //   label:"SecureVaults",
  //   icon:'VaultsIcon',
  //   href:""
  // },
  // {
  //   label:"SecureCard",
  //   icon:'BondsIcon',
  //   href:""
  // },

  // {
  //   label: 'Pools',
  //   icon: 'PoolIcon',
  //   href: '/pools',
  // },
  // {
  //   label: 'Lottery',
  //   icon: 'TicketIcon',
  //   href: '/lottery',
  // },
  // {
  //   label: 'NFT',
  //   icon: 'NftIcon',
  //   href: '/nft',
  // },

  {
    label: 'Price Charts',
    icon: 'GroupsIcon',
    initialOpenState: false,
    items: [
      {
        label: 'Dex Guru',
        href: 'https://dex.guru/token/0x73972F91fbFd8673Eafaab0105481A90D25E153d-bsc',
      },
      {
        label: 'Poo Coin',
        href: 'https://poocoin.app/tokens/0x73972F91fbFd8673Eafaab0105481A90D25E153d',
      },
      {
        label: 'Bogged Finance',
        href: 'https://charts.bogged.finance/?token=0x73972F91fbFd8673Eafaab0105481A90D25E153d',
      },
      {
        label: 'Dex Tools',
        href: 'https://www.dextools.io/app/bsc/pair-explorer/0x2a12fdcbf11ca67560bb8b37e97112694548d1fc',
      },
    ],
  },

  {
    label: 'Audit',
    icon: 'AuditIcon',
    href: '',
  },

  {
    label: 'More',
    icon: 'MoreIcon',
    items: [
      // {
      //   label: 'Github',
      //   href: '',
      // },

      {
        label: 'Yield Calculator',
        href: 'https://vfat.tools/bsc/secureswap/',
      },
      {
        label: 'Docs',
        href: 'https://docs.secureswap.io',
      },
      {
        label: 'Blog',
        href: 'https://secureswap.medium.com/',
      },
    ],
  },
]

export default config
